import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {StorageService} from './storage.service';
import {RmsService} from "./rms.service";

@Injectable({
  providedIn: 'root'
})
export class MailingService {

  private static path = window.location.protocol + '//api.ahacafe.vn/';
  constructor(
      private http: HttpClient,
      private storage: StorageService,
      private rms: RmsService,
  ) {
  }

  send(config: MailConfig, onCompleted?: (succeed: boolean) => void) {
    let payload = {
      CredentialID: this.rms.getToken(),
      CredentialType: 3,
      Data: {
        Receivers: config.receivers,
        Name: config.name,
        Account: config.account,
        Subject: config.subject,
        Content: this.encode(config.css == null ? {} : config.css, config.content == null ? "" : config.content),
        Attachments: []
      }
    }
    if (typeof config.attachments != "undefined") config.attachments.forEach(i => {
      payload.Data.Attachments.push({
        FileName:i.filename,
        Base64Content: i.base64Content,
      });
    });
    let headers = new HttpHeaders().set('Content-Type','application/json');
    this.http.post(MailingService.path +'pom.common.mail', JSON.stringify(payload), { headers: headers}).subscribe((rs:any) => {
      if (typeof onCompleted == "function") onCompleted(rs.Data == true);
    });
  }

  private encode(css: object, content: string): string {

    return '<!doctype html><html><head><meta name="viewport" content="width=device-width"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><title>AHA CAFE</title><style>' + this.obj2css(css) + '</style></head><body>' + content + '</body></html>';
  }

  private obj2css(obj: object) {
    let css = '';

    for (let name in obj) {
      switch (typeof obj[name]) {
        case 'object':
          css += name + "{" + this.obj2css(obj[name]) + "}";
          break;
        default:
          css += name + ":" + obj[name] + ";";
          break;
      }
    }

    return css;
  }
}

export enum MailAccount {
  Accountant = 'accounting',
  Info = 'info',
  Report = 'report'
}

export class MailingDefault {
  public static Style: object = {
    '@media all': {
      '.text-success': {
        'color': '#00982a'
      },

      '.text-primary': {
        'color': '#2191a1'
      },

      '.text-danger': {
        'color': '#dc0044'
      },

      '.text-left': {
        'text-align': 'left'
      },

      '.text-uppercase': {
        'text-transform': 'uppercase'
      },

      '.text-right': {
        'text-align': 'right'
      },

      '.text-warning': {
        'color': '#ff902b'
      },

      'thead > tr > th': {
        'padding': '14px 8px',
      },

      'table th, table td': {
        'padding': '8px',
        'vertical-align': 'top',
        'border': '1px solid #ddd',
        'border-collapse' : 'collapse'
      },

      'table': {
        'border-collapse': 'collapse',
        'margin': '20px auto',
        'width': '100%'
      }
    }
  }
}

export interface MailAttachment {
  filename: string;
  base64Content: string;
}

export interface MailConfig {

  name: string;
  account: MailAccount;

  receivers: Array<string>;

  subject: string;
  css?: object;
  content: string;
  attachments?: Array<MailAttachment>;
}
